import FullDayCalendarOffBatchList from "./FullDayCalendarOffBatchList";
import FullDayCalendarBatchEdit from "./FullDayCalendarOffBatchEdit";
import FullDayCalendarBatchCreate from "./FullDayCalendarOffBatchCreate";

export default {
    list: FullDayCalendarOffBatchList,
    create: FullDayCalendarBatchCreate,
    edit: FullDayCalendarBatchEdit
};
